import React, { FC } from 'react';

import { BoxChild, FooterWrapper } from './product-cta.styled';
import { IProductCtaWrapperProps } from './types';

// Wrapper for the CTA buttons depending on the device
export const ProductCtaWrapper: FC<React.PropsWithChildren<IProductCtaWrapperProps>> = ({
  elements,
}) => {
  const elementsToRender = elements.filter(({ element }) => element);

  return (
    <FooterWrapper testID="product-cta-footer-banner">
      {elementsToRender.map(({ element, spaces }, idx) => (
        <BoxChild key={idx} lastChild={idx === elementsToRender.length - 1} spaces={spaces}>
          {element}
        </BoxChild>
      ))}
    </FooterWrapper>
  );
};
